import { Avatar, Box, Button } from '@mui/material';
import styled from 'styled-components';

export const StyledAvatarWrapper = styled(Avatar)`
  background-color: var(--color-deep-purple);
  width: 50px;
  height: 45px;
  margin: var(--spacing-md);
`;

export const StyledFormContainer = styled(Box)`
  margin-top: var(--spacing-xs);
  display: flex;
  flex-direction: column;
  align-items: center;
  align-items: center;
  margin: auto;
  text-align: center;
`;

export const StyledFormButton = styled(Button)`
  margin-bottom: var(--spacing-md);
`;

export const CenteredDiv = styled.div`
  text-align: center;
  margin-top: var(--spacing-md);
`;
